import { artifactClient } from '../connect/clients';
function timestampToDate(ts) {
    if (!ts) return new Date(0);
    return new Date(Number(ts.seconds) * 1000);
}
function timestampToString(ts) {
    if (!ts) return '';
    return new Date(Number(ts.seconds) * 1000).toISOString();
}
export async function listChatArtifacts(params = {}) {
    const { limit = 50, offset = 0, kind, sortBy = 'recent', search } = params;
    const res = await artifactClient.listChatArtifacts({
        kinds: kind ? kind.split(',').filter(Boolean) : [],
        search: search ?? '',
        sortBy,
        offset: BigInt(offset),
        limit: BigInt(limit)
    });
    const total = Number(res.total);
    return {
        artifacts: res.artifacts.map((a)=>({
                id: a.id,
                title: a.title,
                kind: a.kind,
                chatId: a.chatId,
                createdAt: timestampToDate(a.createdAt),
                updatedAt: timestampToDate(a.updatedAt)
            })),
        total,
        hasMore: offset + res.artifacts.length < total
    };
}
function toDocument(v) {
    return {
        id: v.id,
        title: v.title,
        kind: v.kind,
        content: v.content,
        // The express payload exposed the row's owner here. Every read is now
        // owner-scoped by the PDP, so the only identity worth surfacing is the
        // author of this particular version — which may be "ai".
        userId: v.createdBy,
        createdAt: timestampToString(v.createdAt),
        updatedAt: timestampToString(v.updatedAt)
    };
}
export async function getChatArtifact(documentId, limit = 10, offset = 0) {
    const res = await artifactClient.getChatArtifact({
        id: documentId,
        versionsOffset: BigInt(offset),
        versionsLimit: BigInt(limit)
    });
    if (!res.latest) {
        throw new Error('Document not found');
    }
    const total = Number(res.versionsTotal);
    return {
        latest: toDocument(res.latest),
        versions: res.versions.map(toDocument),
        pagination: {
            total,
            limit,
            offset,
            hasMore: offset + res.versions.length < total
        }
    };
}
/**
 * Create-or-append. An unknown id creates the document; a known one appends a
 * version. This mirrors the express handler it replaces, which silently doubled
 * as create, update and version-append.
 */ export async function saveChatArtifact(documentId, payload) {
    const res = await artifactClient.saveChatArtifact({
        id: documentId,
        title: payload.title ?? '',
        kind: payload.kind ?? 'text',
        content: payload.content ?? '',
        chatId: payload.chatId ?? ''
    });
    if (!res.artifact) {
        throw new Error('Save returned no artifact');
    }
    return {
        document: toDocument(res.artifact),
        changeType: res.artifact.changeType
    };
}
/**
 * Soft-delete a chat artifact (all versions). Ownership is enforced server-side
 * against the stored row — the caller can only delete their own.
 */ export async function deleteChatArtifact(documentId) {
    await artifactClient.deleteChatArtifact({
        id: documentId
    });
}
